import React from "react";
import './index.css'

const CustomInput = ({type, Icon, placeHolder,handleUpdateVisoriaInfo, keyInput})=>{
    return(
        <div className="custom-input-container">
            <input onChange={e => handleUpdateVisoriaInfo(e, keyInput)} type={type} placeholder={placeHolder}  />
            {Icon}

        </div>
    )
}

export default CustomInput